import React, { useEffect } from 'react';

import Monitoring from './components/dashboard/Monitoring';

function MobileAccess() {  
    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
      // Update the document title using the browser API
      
    });
  
    return (
      <div>
        <Monitoring isMobile/>
      </div>
    );
  }

  export default MobileAccess;